<template>
  <div class="demo">
    <div class="d-none d-md-block">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <device-info/>
  </div>
</template>

<script>
import DeviceInfo from '@/components/DeviceInfo';

export default {
  components: { DeviceInfo },
  data() {
    return {
      demoEvaluationComplete: false,
    };
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/Demo/Index.vue